document.addEventListener('DOMContentLoaded', () => {
  const input = document.querySelector('input[type="search"]');
  function typeInPlaceholders(input) {
    const typingSpeed = input.dataset.typingSpeed || 100;
    const deletingSpeed = input.dataset.deletingSpeed || 60;
    const delayAfterDeleting = input.dataset.delayAfterDeleting || 500;
    const delayBeforeFirstDelete = input.dataset.delayBeforeFirstDelete || 2000;
    const delayAfterWordTyped = input.dataset.delayAfterWordTyped || 2400;
    const placeholders = [];

    if (input.placeholder) {
      placeholders.push(input.placeholder);
    }

    if (input.dataset.placeholderTwo) {
      placeholders.push(input.dataset.placeholderTwo);
    }

    if (input.dataset.placeholderThree) {
      placeholders.push(input.dataset.placeholderThree);
    }

    const typeInNextPlaceholder = async (placeholder) => {
      await new Promise((resolve) => {
        let currentPlaceholder = input.getAttribute('placeholder') || '';

        let nextPlaceholder = (currentPlaceholder.length >= 3 && placeholder.startsWith(currentPlaceholder))
          ? placeholder.replace(currentPlaceholder, '')
          : placeholder;

        const typingIntervalId = setInterval(() => {
          currentPlaceholder = input.getAttribute('placeholder') || '';
          input.setAttribute('placeholder', currentPlaceholder + nextPlaceholder.charAt(0));
          if (nextPlaceholder.length === 1) {
            resolve();
            clearInterval(typingIntervalId);
          } else {
            nextPlaceholder = nextPlaceholder.substring(1);
          }
        }, typingSpeed);
      });
    };

    const deleteCurrentPlaceholder = async (nextPlaceholder) => {
      await new Promise((resolve) => {
        let prevPlaceholder = input.getAttribute('placeholder') || '';
        const deletionIntervalId = setInterval(() => {
          const newPlaceholder = prevPlaceholder.substring(0, prevPlaceholder.length - 1);
          input.setAttribute('placeholder', newPlaceholder);
          prevPlaceholder = newPlaceholder;
          if (prevPlaceholder.length === 0 || (prevPlaceholder.length >= 3 && nextPlaceholder.startsWith(prevPlaceholder))) {
            resolve();
            clearInterval(deletionIntervalId);
          }
        }, deletingSpeed);
      });
    };

    let startIndex = 0;
    const showNextPlaceholder = () => {
      startIndex = (startIndex + 1) % placeholders.length;
      const nextPlaceholder = placeholders[startIndex];
      deleteCurrentPlaceholder(nextPlaceholder).then(() => {
        setTimeout(() => {
          typeInNextPlaceholder(nextPlaceholder).then(() => {
            setTimeout(showNextPlaceholder, delayAfterWordTyped);
          });
        }, delayAfterDeleting);
      });
    };

    setTimeout(showNextPlaceholder, delayBeforeFirstDelete);
  }

  if (input) {
    typeInPlaceholders(input);
  }
});